import _concat from "lodash/concat";
import _slice from "lodash/slice";
import _keyBy from "lodash/keyBy";
import _filter from "lodash/filter";
import _merge from "lodash/merge";
import _uniqueId from "lodash/uniqueId";

// create a new empty row
export const createRow = (attrs) => {
    return _merge(
        {
            id: _uniqueId("row-"),
            title: "",
            meta: {},
            depth: 0,
        },
        attrs
    );
};

// insert values in an array at index
export const insertAt = (arr, values, index) => {
    let newArr = [];

    // get previous items
    newArr = _concat(newArr, _slice(arr, 0, index));

    // add values
    newArr = _concat(newArr, values);

    // get next items
    newArr = _concat(newArr, _slice(arr, index));

    return newArr;
};

// remove nth elements from array at index
export const removeAt = (arr, index, nth) => {
    if (nth === undefined) {
        nth = 1;
    }

    let newArr = [];

    // get previous items
    newArr = _concat(newArr, _slice(arr, 0, index));

    // get next items
    newArr = _concat(newArr, _slice(arr, index + nth));

    return newArr;
};

const getDepthFromString = (string) => {
    let d = 0;
    for (let i = 0; i < string.length; i++) {
        if (string[i] === "\t") {
            d++;
            continue;
        }
        break;
    }

    return d;
};

const getTreeChildren = (row, rows) => {
    let children = [];

    let key = row.key;
    while (true) {
        let child = rows[key + "-" + (children.length + 1)];
        if (child === undefined) {
            break;
        }
        children.push({
            title: child.title,
            meta: child.meta,
            children: getTreeChildren(child, rows),
        });
    }
    return children;
};

export const textToRows = (text) => {
    let rows = [];
    let splittedText = text.split("\n");

    for (let i = 0; i < splittedText.length; i++) {
        // get the depth for the line
        let depth = getDepthFromString(splittedText[i]);

        // get the value for the line
        let title = splittedText[i].trim().replace(/\t/g, "");

        // if the value is empty, skip the line
        if (title.length === 0) {
            continue;
        }

        // create the row
        rows.push(
            createRow({
                title: title,
                meta: {},
                depth: depth,
            })
        );
    }

    return rows;
};

export const treeToRows = (nodes, depth) => {
    let output = [];

    if (depth === undefined) {
        depth = 0;
    }

    nodes.forEach((node) => {
        output.push({
            id: _uniqueId("row-"),
            title: node.title,
            meta: node.meta ?? {},
            depth: depth,
        });
        if (node.children) {
            output = _concat(output, treeToRows(node.children, depth + 1));
        }
    });

    return output;
};

export const rowsToTree = (rows) => {
    let nodes = [];
    let maxPossibleDepth = 0;
    let keys = [];

    for (let i = 0; i < rows.length; i++) {
        // get the depth for the row
        let depth = Math.min(maxPossibleDepth, rows[i].depth);

        // get the value for the line
        let title = rows[i].title.trim();

        // if the value is empty, skip the line
        if (title.length === 0) {
            continue;
        }

        // create the keys array
        let newKeys = [];
        for (let j = 0; j <= depth; j++) {
            newKeys[j] = keys[j] || 0;
            if (j === depth) {
                newKeys[j]++;
            }
        }

        // create the node
        nodes.push({
            title: title,
            meta: rows[i]?.meta ?? {},
            key: newKeys.join("-"),
            depth: depth,
        });

        // set new values for keys and maxPossibleDepth
        keys = newKeys;
        maxPossibleDepth = depth + 1;
    }

    nodes = _keyBy(nodes, "key");
    nodes = _filter(nodes, ["depth", 0]).map((node) => {
        return {
            title: node.title,
            meta: node.meta,
            children: getTreeChildren(node, nodes),
        };
    });

    return nodes;
};
